export enum ChromePortName {
    PRINT = 'print',
}
